// src/components/artists/ArtistReleases.tsx - Mit wachsender Höhe
import React from 'react';
import { RocketLaunchIcon, CalendarIcon } from '@heroicons/react/24/outline';

interface Release {
  id: number;
  name: string;
  date: string;
  type: string;
}

interface ArtistReleasesProps {
  releases: Release[];
}

export const ArtistReleases: React.FC<ArtistReleasesProps> = ({ releases }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-700 mb-4">Releases</h2>
      <div style={{ minHeight: "50px" }} className="overflow-auto">
        {releases.length > 0 ? (
          <ul className="space-y-3">
            {releases.map(release => (
              <li key={release.id} className="flex items-center justify-between border-b border-gray-100 pb-2 last:border-0 last:pb-0">
                <div className="flex items-center">
                  <RocketLaunchIcon className="h-5 w-5 text-gray-400 mr-2" />
                  <div>
                    <p className="font-medium text-gray-900">{release.name}</p>
                    <p className="text-xs text-gray-500">{release.type}</p>
                  </div>
                </div>
                <div className="flex items-center text-gray-500 text-sm">
                  <CalendarIcon className="h-4 w-4 mr-1" />
                  {new Date(release.date).toLocaleDateString('en-US', { 
                    day: '2-digit', 
                    month: '2-digit', 
                    year: 'numeric' 
                  })}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500 text-center py-2">No releases found</p>
        )}
      </div>
    </div>
  );
};